import { customAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const arcsightEsm = defineConnector({
  identifier: "arcsightEsm",
  name: "ArcSight ESM",
  tagLine: "Security information and event management",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: ({ apiAddress }) =>
    apiAddress
      ? `${apiAddress.replace(/\./g, "\\.").replace(/\/$/, "")}/.*`
      : "https://.*/.*",
  auth: customAuth("arcsightEsm"),
  steps: [
    {
      title: "Enter your ArcSight ESM details",
      items: [
        {
          kind: "url",
          label: "API address",
          placeholder: "https://arcsight.example.com:8443",
          required: true,
          target: { kind: "configuration", field: "apiAddress" },
          helperText: "The base URL of your ArcSight ESM manager.",
        },
        {
          kind: "input",
          label: "Username",
          required: true,
          target: { kind: "configuration", field: "username" },
        },
        {
          kind: "input",
          label: "Password",
          required: true,
          target: { kind: "secrets", field: "password" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ apiAddress }) =>
      `${(apiAddress ?? "").replace(/\/$/, "")}/www/manager-service/rest/CaseService/findAllIds?alt=json`,
  },
});
